import {Pipe, PipeTransform} from '@angular/core';
import {ModuleModel} from '../models/module.model';

@Pipe({
  name: 'lbaModuleFilterPipe',
})
export class ModuleFilterPipe implements PipeTransform {

  transform(modules: Array<ModuleModel>, searchStr: string): any {
    searchStr = searchStr.toString().toLowerCase();
    const filteredModules: Array<ModuleModel> = [];
    if (searchStr.length === 0) {
      return modules;
    }
    for (const module of modules){
      if (
        module.name.toLowerCase().indexOf(searchStr) !== -1 ||
        module.id.toString().indexOf(searchStr) !== -1
      ) {
        filteredModules.push(module);
      }
    }
    return filteredModules;
  }

}
